import { MathUtils } from 'three';
import type { ToolId } from '../config/toolConfig';

export interface ScoreInput {
  success: boolean;
  elapsed: number;
  rescueTime: number;
  accuracy: number;
  timing: number;
  tool: ToolId | 'observe';
  recommended: ToolId | 'observe';
  secondaryAttempts: number;
  injury: boolean;
  stamina: number;
}

export interface ScoreResult {
  total: number;
  grade: 'S' | 'A' | 'B' | 'C' | 'D' | 'F';
  title: string;
  lines: Array<{ label: string; value: number }>;
}

export function calculateScore(input: ScoreInput): ScoreResult {
  if (!input.success) {
    return {
      total: 0,
      grade: 'F',
      title: '请先拨打救援电话',
      lines: [
        { label: '救援结果', value: 0 },
        { label: '二次危险', value: input.injury ? -100 : 0 },
      ],
    };
  }

  const speed = Math.round(MathUtils.clamp(1 - input.elapsed / input.rescueTime, 0, 1) * 300);
  const accuracy = Math.round(MathUtils.clamp(input.accuracy, 0, 1) * 250);
  const timing = Math.round(MathUtils.clamp(input.timing, 0, 1) * 120);
  const correctTool = input.tool === input.recommended ? 180 : 80;
  const safe = input.injury ? 0 : 100;
  const stamina = Math.round(MathUtils.clamp(input.stamina, 0, 1) * 100);
  const waste = -input.secondaryAttempts * 50;
  const total = MathUtils.clamp(speed + accuracy + timing + correctTool + safe + stamina + waste, 0, 1000);
  const [grade, title]: [ScoreResult['grade'], string] =
    total >= 900
      ? ['S', '水上救援大师']
      : total >= 780
        ? ['A', '专业救援员']
        : total >= 630
          ? ['B', '热心市民']
          : total >= 480
            ? ['C', '手忙脚乱']
            : total >= 300
              ? ['D', '越救越危险']
              : ['F', '请先拨打救援电话'];
  return {
    total,
    grade,
    title,
    lines: [
      { label: '救援速度', value: speed },
      { label: '操作准确', value: accuracy },
      { label: '时机把握', value: timing },
      { label: '道具判断', value: correctTool },
      { label: '无二次伤害', value: safe },
      { label: '剩余体力', value: stamina },
      { label: '道具浪费', value: waste },
    ],
  };
}
